//----------------------------------------------------
// src/components/PinturaTest.jsx — Losse test voor Pintura editor
//----------------------------------------------------
import React, { useRef, useState } from "react";
import {
  openDefaultEditor,
  setPlugins,
  plugin_crop,
  plugin_annotate,
  plugin_filter,
  plugin_resize,
} from "@pqina/pintura";
import locale_nl_NL from "@pqina/pintura/locale/nl_NL";
import "@pqina/pintura/pintura.css";

// 🧩 Plugins activeren
setPlugins(plugin_crop, plugin_annotate, plugin_filter, plugin_resize);

export default function PinturaTest() {
  const inputRef = useRef();
  const [preview, setPreview] = useState(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const edited = await openDefaultEditor({
      src: URL.createObjectURL(file),
      locale: locale_nl_NL, // 🇳🇱 Nederlandse interface
      imageCropAspectRatio: 1,
      imageWriter: { mimeType: "image/jpeg", quality: 0.9 },
    });

    if (!edited || !edited.dest) return;
    setPreview(edited.dest);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6">
      <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md text-center">
        <h2 className="text-xl font-semibold mb-3">📸 Pintura Testomgeving</h2>
        <p className="text-gray-600 mb-4">
          Kies een afbeelding en bewerk deze met de Pintura-editor.
        </p>

        <input
          type="file"
          accept="image/*"
          ref={inputRef}
          onChange={handleFileChange}
          className="mb-4"
        />

        {preview && (
          <div className="mt-4">
            <p className="text-sm text-gray-600 mb-2">Voorbeeld na bewerking:</p>
            <img
              src={preview}
              alt="preview"
              className="rounded-lg border border-gray-300 shadow-sm"
            />
          </div>
        )}
      </div>
    </div>
  );
}
